import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs";
import { User } from "src/app/shared/models/user.model";
import { UserService } from "src/app/shared/services/user.service";
import { SiteDTO } from "../models/siteDTO.model";
import { SitesService } from "../services/sites.service";
import {
  GetSitesAction,
  GetUserAction,
  GetUserFullAction,
} from "./user-profile.actions";
import { NamePipe } from "../pipe/name.pipe";

export interface UserProfileStateModel {
  user: User | undefined;
  sites: SiteDTO[];
}

@State<UserProfileStateModel>({
  name: "UserProfileStore",
  defaults: {
    user: undefined,
    sites: [],
  },
})
@Injectable()
export class UserProfileState {
  constructor(
    private sitesService: SitesService,
    private userService: UserService,
  ) {}

  @Selector()
  static selectSites(state: UserProfileStateModel) {
    return state.sites;
  }

  @Selector()
  static selectUser(state: UserProfileStateModel) {
    return state.user;
  }

  @Selector()
  static selectCurrentUserSite(state: UserProfileStateModel) {
    let id = state.user?.idSite;
    return state.sites.find((site) => site.id === id);
  }

  @Action(GetUserAction)
  getUserAction(ctx: StateContext<UserProfileStateModel>) {
    return this.userService.parseTokenAndFetchUserObservable().pipe(
      tap((user) => {
        user.name = new NamePipe().transform(user.email, "name");
        user.surname = new NamePipe().transform(user.email, "surname");
        const state = ctx.getState();
        ctx.setState({
          ...state,
          user,
        });
      }),
    );
  }

  @Action(GetUserFullAction)
  getUserFullAction(ctx: StateContext<UserProfileStateModel>) {
    return this.userService.getUserFull().pipe(
      tap((user) => {
        user.name = new NamePipe().transform(user.email, "name");
        user.surname = new NamePipe().transform(user.email, "surname");
        const state = ctx.getState();
        ctx.setState({
          ...state,
          user,
        });
      }),
    );
  }

  @Action(GetSitesAction)
  getSitesAction(ctx: StateContext<UserProfileStateModel>) {
    return this.sitesService.getAll().pipe(
      tap((sites) => {
        const sorted = [...sites].sort((a, b) => Number(a.id) - Number(b.id));
        ctx.patchState({ sites: sorted });
      }),
    );
  }
}
